import React, { useEffect } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useHelp } from "./useHelp";

const HelpWindow = ({ title, children }) => {
  const { getHelp, help } = useHelp()


  useEffect(() => {
    //console.log("Help is " + getHelp())
  }, [help])

  // <Drawer
  //         key="help-drawer"
  //         disableEnforceFocus
  //         hideBackdrop
  //         sx={{ minHheight: 300, maxHeight: 1000 }}
  //         style={{ overflow: "scroll", pointerEvents: 'none', minHeight: 300, maxHieght: 1000 }}
  //         PaperProps={{ style: { backgroundColor: "#dddddd", pointerEvents: 'auto' } }}
  //         anchor="bottom" open={getHelp()} >


  return (
    <>
      {getHelp() && (
        <Box
          key="help-drawer"
          sx={{
            m: 2, p: 2,
            textAlign: "left",
            minHeight: 200,
            maxHeight: 400,
            overflow: "scroll",
            border: "2px solid #17be34"
          }}
        >
          <Stack>
            {/* <Stack direction="row" spacing={4}> */}
            <Typography id="s-die-age-slider" variant="h6" gutterBottom>
              {"Help: " + title}
            </Typography>
            {/* </Stack> */}
            <Stack >
              {children}
            </Stack>
          </Stack>
        </Box >
      )}
    </>
  );
};

export default HelpWindow;


